/**
 * Auto-generated CJK pixel font glyphs extracted from Cubic 11 SFD.
 * DO NOT EDIT — regenerate with: bun run scripts/extract-sfd-bitmaps.ts
 */
export const CJK_GLYPHS: Record<string, string[]> = {
    開: [
        '#####.#####',
        '#...#.#...#',
        '#####.#####',
        '#...#.#...#',
        '#####.#####',
        '#.........#',
        '#.#######.#',
        '#...#.#...#',
        '#.#######.#',
        '#...#.#...#',
        '#..#..#..##',
    ],
    始: [
        '.#.....#...',
        '.#....#...#',
        '####.#....#',
        '.#.#.######',
        '.#.#.......',
        '.#.#.......',
        '#..#.######',
        '###..#....#',
        '..##.#....#',
        '.#...#....#',
        '.#...######',
    ],
    佈: [
        '..#....#...',
        '..#.#######',
        '.#....#....',
        '.#....#.#..',
        '##...#..#..',
        '.#..#######',
        '.#.#.#..#.#',
        '.#...#..#.#',
        '.#...#..#.#',
        '.#...#..###',
        '.#......#..',
    ],
    軌: [
        '..#....#...',
        '#####..#...',
        '..#..#####.',
        '#####..#.#.',
        '#.#.#..#.#.',
        '#####..#.#.',
        '#.#.#..#.#.',
        '#####.#..#.',
        '..#...#..#.',
        '######...#.',
        '..#..#...##',
    ],
    結: [
        '..#.....#..',
        '.#...######',
        '#..#....#..',
        '####....#..',
        '..#..######',
        '.#.........',
        '#####......',
        '..#...#####',
        '#.#.#.#...#',
        '#.#.#.#...#',
        '..#...#####',
    ],
    束: [
        '.....#.....',
        '###########',
        '.....#.....',
        '.#########.',
        '.#...#...#.',
        '.#...#...#.',
        '.#########.',
        '....##.....',
        '...#.#.#...',
        '..#..#..#..',
        '##...#...##',
    ],
    刪: [
        '.#####....#',
        '.#.#.#.#..#',
        '.#.#.#.#..#',
        '.#.#.#.#..#',
        '.#.#.#.#..#',
        '########..#',
        '.#.#.#.#..#',
        '.#.#.#.#..#',
        '.#.#.#....#',
        '.#.#.#....#',
        '.#.#.#...##',
    ],
    除: [
        '###..####..',
        '#.#.#....#.',
        '#.##......#',
        '##..#######',
        '#.#....#...',
        '#.#....#...',
        '#.#########',
        '#.#....#...',
        '##..#..#.#.',
        '#..#...#..#',
        '#.....##...',
    ],
    道: [
        '.#...#..#..',
        '..#.#######',
        '.......#...',
        '#....#####.',
        '.#...#...#.',
        '.....#####.',
        '###..#...#.',
        '..#..#...#.',
        '..#..#####.',
        '.#.#.......',
        '#...#######',
    ],
    放: [
        '..#...#....',
        '..#...#####',
        '#####.#..#.',
        '..#..#...#.',
        '..#..#...#.',
        '..###..#.#.',
        '.#..#..#.#.',
        '.#..#...#..',
        '#...#...#..',
        '#...#..#.#.',
        '..##.##...#',
    ],
    置: [
        '.#########.',
        '.#..#.#..#.',
        '.#########.',
        '.....#.....',
        '###########',
        '..#.....#..',
        '..#######..',
        '..#.....#..',
        '..#######..',
        '..#.....#..',
        '###########',
    ],
    列: [
        '######....#',
        '..#....#..#',
        '..#....#..#',
        '..####.#..#',
        '.#...#.#..#',
        '.##..#.#..#',
        '#..#.#.#..#',
        '....#..#..#',
        '....#.....#',
        '..##......#',
        '##.......##',
    ],
    車: [
        '.....#.....',
        '###########',
        '.....#.....',
        '.#########.',
        '.#...#...#.',
        '.#########.',
        '.#...#...#.',
        '.#########.',
        '.....#.....',
        '###########',
        '.....#.....',
    ],
    清: [
        '.......#...',
        '#..########',
        '.#.....#...',
        '....#######',
        '#......#...',
        '.#.########',
        '....#.....#',
        '....#######',
        '..#.#.....#',
        '.#..#######',
        '#...#.....#',
    ],
    單: [
        '.####.####.',
        '.#..#.#..#.',
        '.#..#.#..#.',
        '.#########.',
        '..#..#..#..',
        '..#######..',
        '..#..#..#..',
        '..#######..',
        '.....#.....',
        '###########',
        '.....#.....',
    ],
    關: [
        '#####.#####',
        '#...#.#...#',
        '#####.#####',
        '#...#.#...#',
        '#####.#####',
        '#..#...#..#',
        '#.#.#.#.#.#',
        '#..#.#.#..#',
        '#.#.#.#.#.#',
        '#.###.###.#',
        '#..#..#..##',
    ],
    閉: [
        '#####.#####',
        '#...#.#...#',
        '#####.#####',
        '#...#.#...#',
        '#####.#####',
        '#.....#...#',
        '#.#######.#',
        '#....##...#',
        '#...#.#...#',
        '#.##..#...#',
        '#....##..##',
    ],
    啟: [
        '...##.#....',
        '.##...#####',
        '.#....#..#.',
        '.####.#..#.',
        '.#..#....#.',
        '.####..#.#.',
        '.#.....#.#.',
        '#.####..#..',
        '#.#..#..#..',
        '#.#..#.#.#.',
        '..#####...#',
    ],
    庫: [
        '......#....',
        '.##########',
        '.#.....#...',
        '.#.########',
        '.#.#...#..#',
        '.#.########',
        '.#.#...#..#',
        '.#.########',
        '.#.....#...',
        '#.#########',
        '#......#...',
    ],
    編: [
        '..#.#######',
        '.#..#......',
        '#...#######',
        '###.#.....#',
        '..#.#######',
        '.#..#......',
        '###########',
        '..#.#.#.#.#',
        '#.#.#######',
        '#.#.#.#.#.#',
        '..#.#.#.#.#',
    ],
    輯: [
        '..#...#####',
        '#####.#...#',
        '..#...#####',
        '#####......',
        '#.#.#######',
        '#####.#...#',
        '#.#.#.#####',
        '#####.#...#',
        '..#...#####',
        '#######...#',
        '..#.......#',
    ],
    組: [
        '..#..#####.',
        '.#...#...#.',
        '#..#.#...#.',
        '####.#####.',
        '..#..#...#.',
        '.#...#...#.',
        '####.#####.',
        '..#..#...#.',
        '#.##.#...#.',
        '#.#..#...#.',
        '..#.#######',
    ],
    建: [
        '.......#...',
        '###.#######',
        '..#....#..#',
        '.#.########',
        '#......#..#',
        '###..######',
        '..#....#...',
        '#.#.#######',
        '.#.....#...',
        '.##........',
        '#..########',
    ],
    築: [
        '.#....#....',
        '.####.#####',
        '#..#.#..#..',
        '#####.####.',
        '..#...#..#.',
        '####.#.#.##',
        '.....#.....',
        '###########',
        '....##.#...',
        '..##.#..#..',
        '##...#...##',
    ],
    站: [
        '..#....#...',
        '..#....#...',
        '#####..####',
        '...#...#...',
        '.#.#...#...',
        '.#.#...#...',
        '.#.#.######',
        '.#.#.#....#',
        '...#.#....#',
        '######....#',
        '.....######',
    ],
    顯: [
        '#####.#####',
        '#...#...#..',
        '#####.#####',
        '#...#.#...#',
        '#####.#####',
        '.#.#..#...#',
        '#.#.#.#####',
        '#####.#...#',
        '......#####',
        '.#.#.#.#.#.',
        '#.#.#.#...#',
    ],
    示: [
        '.#########.',
        '...........',
        '...........',
        '...........',
        '###########',
        '.....#.....',
        '.....#.....',
        '..#..#..#..',
        '.#...#...#.',
        '#....#....#',
        '....##.....',
    ],
    高: [
        '.....#.....',
        '###########',
        '...#...#...',
        '...#####...',
        '...........',
        '###########',
        '#.........#',
        '#..#####..#',
        '#..#...#..#',
        '#..#####..#',
        '#........##',
    ],
    度: [
        '......#....',
        '.##########',
        '.#..#...#..',
        '.##########',
        '.#..#...#..',
        '.#..#####..',
        '.#.........',
        '#..#######.',
        '#...#...#..',
        '....####...',
        '.###....###',
    ],
    漸: [
        '....#...###',
        '#.#######..',
        '.#..#...#..',
        '..#####.###',
        '#.#.#.#.#.#',
        '.######.#.#',
        '..#.#.#.#.#',
        '.######.#.#',
        '.#..#...#.#',
        '#.######..#',
        '#...#..#..#',
    ],
    層: [
        '.##########',
        '.#........#',
        '.##########',
        '.#.#...#..#',
        '.#.#.#.##.#',
        '.#.#...#..#',
        '.#.########',
        '.#..#....#.',
        '#...######.',
        '#...#....#.',
        '....######.',
    ],
    隱: [
        '###.#####.#',
        '#.#.#..#..#',
        '#.#..#.#.#.',
        '##.########',
        '#.#.......#',
        '#.#.#######',
        '#.#.......#',
        '#.#.#######',
        '##...#.#...',
        '#..#.#...#.',
        '#.#...###.#',
    ],
    藏: [
        '...#...#...',
        '###########',
        '...#...#.#.',
        '#.#########',
        '#.#.#...#..',
        '#######.#.#',
        '..#...#.#.#',
        '#######..#.',
        '#.#.#....#.',
        '#.#####.#.#',
        '#.#...##..#',
    ],
    預: [
        '####.######',
        '...#...#...',
        '#.#..######',
        '.#...#....#',
        '####.######',
        '.#.#.#....#',
        '.#.#.######',
        '.##..#....#',
        '.#...######',
        '.#....#..#.',
        '##..##....#',
    ],
    覽: [
        '####.######',
        '#.#..#.....',
        '#####.#####',
        '#..#..#.#.#',
        '###########',
        '#.#.....#..',
        '#########..',
        '..#.....#..',
        '..#######..',
        '...#..#...#',
        '###...#####',
    ],
    曲: [
        '...#..#...',
        '...#..#...',
        '##########',
        '#..#..#..#',
        '#..#..#..#',
        '#..#..#..#',
        '##########',
        '#..#..#..#',
        '#..#..#..#',
        '#..#..#..#',
        '##########',
    ],
    線: [
        '..#....#...',
        '.#...######',
        '#..#.#....#',
        '####.######',
        '..#..#....#',
        '.#...######',
        '####....#..',
        '..#..##.#.#',
        '#.#...#.##.',
        '#.#..#..#.#',
        '..#.#..##.#',
    ],
    弧: [
        '###.#######',
        '..#.#.#.#..',
        '..#.#.#.#..',
        '###.#.#.#..',
        '#...#.#.#..',
        '#...#.#..#.',
        '###.#.#..#.',
        '..#.#.#..#.',
        '..#.#.#.#.#',
        '..##.####.#',
        '##.#......#',
    ],
    地: [
        '..#....#...',
        '..#..#.#.##',
        '..#..#.##.#',
        '####.###..#',
        '..#.##.#..#',
        '..#..#.#..#',
        '..#..#.#.##',
        '..#..#.#...',
        '..##.#.....',
        '##...#....#',
        '.....######',
    ],
    圖: [
        '###########',
        '#..#...#..#',
        '#..#####..#',
        '#....#....#',
        '###########',
        '#.#.#.#.#.#',
        '#.#.###.#.#',
        '#.#.....#.#',
        '#.#######.#',
        '#.........#',
        '###########',
    ],
    錯: [
        '..##..#..#.',
        '.#...######',
        '#.....#..#.',
        '#####.#..#.',
        '..#..######',
        '#####......',
        '..#..######',
        '#.##.#....#',
        '#.#..######',
        '..#..#....#',
        '###########',
    ],
    選: [
        '.#..###.###',
        '..#.#.#.#.#',
        '....###.###',
        '#...#...#..',
        '.#..#######',
        '......#.#..',
        '###.#######',
        '..#...#.#..',
        '..#.##...##',
        '.#.#.......',
        '#...#######',
    ],
    項: [
        '...########',
        '###....#...',
        '.#..#######',
        '.#..#.....#',
        '.#..#######',
        '.#..#.....#',
        '.#..#######',
        '.#..#.....#',
        '###.#######',
        '.....#...#.',
        '...##.....#',
    ],
    日: [
        '#########',
        '#.......#',
        '#.......#',
        '#.......#',
        '#.......#',
        '#########',
        '#.......#',
        '#.......#',
        '#.......#',
        '#.......#',
        '#########',
    ],
    照: [
        '####.######',
        '#..#...#..#',
        '#..#..#...#',
        '####.#..##.',
        '#..#.......',
        '#..#.######',
        '####.#....#',
        '.....######',
        '...........',
        '.#.#..#..#.',
        '#...#..#..#',
    ],
    角: [
        '...######.',
        '..#....#..',
        '.#########',
        '##...#...#',
        '.#########',
        '.#...#...#',
        '.#...#...#',
        '.#########',
        '.#.......#',
        '#........#',
        '#......###',
    ],
    形: [
        '######...##',
        '.#..#..##..',
        '.#..#......',
        '.#..#......',
        '######...##',
        '.#..#..##..',
        '.#..#......',
        '.#..#......',
        '.#..#.....#',
        '#...#...##.',
        '#...#.##...',
    ],
    透: [
        '.#..#######',
        '..#....#...',
        '....#######',
        '#....#.#.#.',
        '.#..#..#..#',
        '....#####..',
        '###...#.###',
        '..#...#...#',
        '..#..#..##.',
        '.#.#.......',
        '#...#######',
    ],
    明: [
        '.....######',
        '####.#....#',
        '#..#.#....#',
        '#..#.######',
        '####.#....#',
        '#..#.#....#',
        '#..#.######',
        '####.#....#',
        '.....#....#',
        '....#.....#',
        '..##....###',
    ],
    白: [
        '....#....',
        '...#.....',
        '#########',
        '#.......#',
        '#.......#',
        '#.......#',
        '#########',
        '#.......#',
        '#.......#',
        '#.......#',
        '#########',
    ],
    色: [
        '...#####...',
        '..#....#...',
        '.#....#....',
        '##########.',
        '.#...#...#.',
        '.#...#...#.',
        '.#########.',
        '.#.........',
        '.#........#',
        '.#........#',
        '..#########',
    ],
    遮: [
        '.#.....#...',
        '..#########',
        '...#..#..#.',
        '#..########',
        '.#.#..#..#.',
        '...#..####.',
        '###........',
        '..#.#.#.#.#',
        '..#.#.#.#.#',
        '.#.#.......',
        '#...#######',
    ],
    罩: [
        '.#########.',
        '.#..#.#..#.',
        '.#########.',
        '....#......',
        '....#######',
        '....#......',
        '.#########.',
        '.#.......#.',
        '###########',
        '.....#.....',
        '.....#.....',
    ],
    匯: [
        '###########',
        '#.....#....',
        '#.#...#.#..',
        '#..#.#####.',
        '#.#.##.#...',
        '#..#.#####.',
        '#....#.#...',
        '#..#.#.#...',
        '#.#..#####.',
        '#..........',
        '###########',
    ],
    出: [
        '.....#.....',
        '.#...#...#.',
        '.#...#...#.',
        '.#...#...#.',
        '.#########.',
        '.....#.....',
        '.....#.....',
        '#....#....#',
        '#....#....#',
        '#....#....#',
        '###########',
    ],
    入: [
        '..####.....',
        '.....#.....',
        '.....#.....',
        '.....#.....',
        '....#.#....',
        '....#.#....',
        '...#...#...',
        '...#...#...',
        '..#.....#..',
        '.#.......#.',
        '#.........#',
    ],
    '（': [
        '...#',
        '..#.',
        '.#..',
        '.#..',
        '#...',
        '#...',
        '#...',
        '#...',
        '#...',
        '.#..',
        '.#..',
        '..#.',
    ],
    輛: [
        '..#.#######',
        '#####..#...',
        '..#....#...',
        '###########',
        '#.#.#..#..#',
        '######.##.#',
        '#.#.##.##.#',
        '#####.##.##',
        '..#.#..#..#',
        '#####..#..#',
        '..#.#..#.##',
    ],
    '、': ['#.', '.#'],
    位: [
        '..#....#...',
        '..#....#...',
        '.#.########',
        '.#.........',
        '##...#...#.',
        '.#...#...#.',
        '.#...#...#.',
        '.#...#...#.',
        '.#...#..#..',
        '.#......#..',
        '.#.########',
    ],
    '）': [
        '#...',
        '.#..',
        '..#.',
        '..#.',
        '...#',
        '...#',
        '...#',
        '...#',
        '...#',
        '..#.',
        '..#.',
        '.#..',
    ],
    全: [
        '.######....',
        '...#...#...',
        '..#.....#..',
        '.#.......#.',
        '#.#######.#',
        '.....#.....',
        '.....#.....',
        '..#######..',
        '.....#.....',
        '.....#.....',
        '###########',
    ],
    部: [
        '..#....####',
        '######.#..#',
        '.#..#..#..#',
        '.#..#..#.#.',
        '######.##..',
        '.......#.#.',
        '.......#..#',
        '######.#..#',
        '#....#.#..#',
        '#....#.###.',
        '######.#...',
    ],
    無: [
        '..#........',
        '.##########',
        '#.#.#.#.#..',
        '..#.#.#.#..',
        '###########',
        '..#.#.#.#..',
        '..#.#.#.#..',
        '###########',
        '...........',
        '.#.#..#..#.',
        '#...#..#..#',
    ],
    效: [
        '..#...#....',
        '#####.#####',
        '......#..#.',
        '.#.#..#..#.',
        '#...#....#.',
        '.......#.#.',
        '#...#..#.#.',
        '.#.#....#..',
        '..#.....#..',
        '.#.#...#.#.',
        '#...#.#...#',
    ],
    的: [
        '.#....#....',
        '.#....#####',
        '####.#....#',
        '#..#.#....#',
        '#..#......#',
        '####..#...#',
        '#..#...#..#',
        '#..#......#',
        '#..#......#',
        '####.....#.',
        '.......##..',
    ],
    資: [
        '.....#.....',
        '###..######',
        '....#..#..#',
        '...#..#.#..',
        '.#...#...#.',
        '#.#######.#',
        '..#.....#..',
        '..#######..',
        '..#.....#..',
        '..#######..',
        '##.......##',
    ],
    料: [
        '..#......#.',
        '#.##..#..#.',
        '#.#....#.#.',
        '..#......#.',
        '####.#...#.',
        '..#...#..#.',
        '.##......##',
        '.###...###.',
        '#.#.###..#.',
        '#.#......#.',
        '..#......#.',
    ],
    '：': ['##', '##', '..', '..', '..', '##', '##'],
    定: [
        '.....#.....',
        '###########',
        '#.........#',
        '#.........#',
        '..#######..',
        '.....#.....',
        '.....#.....',
        '..#..#####.',
        '..#..#.....',
        '..####.....',
        '##....#####',
    ],
    義: [
        '...#...#...',
        '###########',
        '.....#.....',
        '.#########.',
        '.....#.....',
        '###########',
        '..#..#....#',
        '###########',
        '..#...#..#.',
        '#####..##..',
        '..#..##..##',
    ],
    從: [
        '..#..#...#.',
        '.#..#...#..',
        '#..#.#.#.#.',
        '......#...#',
        '..#....#...',
        '.#.....#...',
        '##..#..####',
        '.#..#..#...',
        '.#..#..#...',
        '.#..####...',
        '.###....###',
    ],
    器: [
        '.####.####.',
        '.#..#.#..#.',
        '.#..#.#..#.',
        '.####.####.',
        '.....#..#..',
        '###########',
        '...#...#...',
        '#####.#####',
        '.#..#.#..#.',
        '.#..#.#..#.',
        '.####.####.',
    ],
    場: [
        '.#..######.',
        '.#..#....#.',
        '.#..######.',
        '###.#....#.',
        '.#..#######',
        '.#...#.....',
        '.#.########',
        '.#...#..#.#',
        '.#..#..#..#',
        '####..#...#',
        '.....#..##.',
    ],
    景: [
        '.#########.',
        '.#.......#.',
        '.#########.',
        '.#.......#.',
        '.#########.',
        '.....#.....',
        '###########',
        '..#.....#..',
        '..#######..',
        '..#..#..#..',
        '##..##...##',
    ],
    已: [
        '#########.',
        '........#.',
        '........#.',
        '#.......#.',
        '#########.',
        '#.........',
        '#.........',
        '#.........',
        '#........#',
        '#........#',
        '.#########',
    ],
    節: [
        '.#....#....',
        '.####.#####',
        '#..#.#..#..',
        '#####.#####',
        '#...#.#...#',
        '#####.#...#',
        '#...#.#...#',
        '#####.#...#',
        '#..#..#...#',
        '#.#.#.#.###',
        '##..#.#....',
    ],
    廂: [
        '......#....',
        '.##########',
        '.#..#......',
        '.#..#.#####',
        '.######...#',
        '.#..#.#####',
        '.#.##.#...#',
        '.#.##.#####',
        '#.#.###...#',
        '#.#.#.#...#',
        '....#.#####',
    ],
    控: [
        '.#.....#...',
        '.#.########',
        '####..#.#.#',
        '.#.#..#.#..',
        '.#....#.#.#',
        '.#..##..###',
        '.#.........',
        '###.######.',
        '.#.....#...',
        '.#.....#...',
        '##.########',
    ],
    制: [
        '#.#.......#',
        '######.#..#',
        '#.#....#..#',
        '..#....#..#',
        '######.#..#',
        '..#....#..#',
        '######.#..#',
        '#.#..#.#..#',
        '#.#..#....#',
        '#.#.##....#',
        '..#......##',
    ],
    動: [
        '#####..#...',
        '..#....#...',
        '###########',
        '#.#.#..#..#',
        '#####..#..#',
        '#.#.#..#..#',
        '#####..#..#',
        '..#...#...#',
        '#####.#...#',
        '..#......#.',
        '#####..##..',
    ],
    力: [
        '.....#.....',
        '.....#.....',
        '.##########',
        '.....#....#',
        '.....#....#',
        '.....#....#',
        '....#.....#',
        '....#.....#',
        '...#......#',
        '..#.......#',
        '##.....###.',
    ],
    空: [
        '.....#.....',
        '###########',
        '#...#.#...#',
        '#...#.#...#',
        '...#..#....',
        '.##...####.',
        '...........',
        '..#######..',
        '.....#.....',
        '.....#.....',
        '###########',
    ],
    檔: [
        '..#..#.#.#.',
        '..#.#######',
        '#####.#.#.#',
        '..#.#.#.#.#',
        '..#...###..',
        '.##........',
        '.##.#######',
        '#.###..#..#',
        '#.#.#######',
        '..#.#..#..#',
        '..#.#######',
    ],
    切: [
        '.#..#######',
        '.#....#...#',
        '.#....#...#',
        '####..#...#',
        '.#....#...#',
        '.#....#...#',
        '.#...#....#',
        '.#...#....#',
        '..###.....#',
        '....#....#.',
        '.......##..',
    ],
    換: [
        '.#...#####.',
        '.#..#...#..',
        '###########',
        '.#..#.#.#.#',
        '.#..#.#.#.#',
        '.#..##..###',
        '.##.#..#..#',
        '##.########',
        '.#....#.#..',
        '.#...#...#.',
        '##.##.....#',
    ],
    方: [
        '.....#.....',
        '###########',
        '....#......',
        '....#......',
        '....######.',
        '....#....#.',
        '...#.....#.',
        '...#.....#.',
        '..#......#.',
        '..#.....#..',
        '.....###...',
    ],
    向: [
        '.....#.....',
        '....#......',
        '###########',
        '#.........#',
        '#.........#',
        '#..#####..#',
        '#..#...#..#',
        '#..#...#..#',
        '#..#####..#',
        '#.........#',
        '#.......###',
    ],
    移: [
        '...##..#...',
        '###...#####',
        '..#.##....#',
        '..#...#..#.',
        '####...##..',
        '..#..##....',
        '.##...#####',
        '.##.##....#',
        '#.#...#..#.',
        '#.#....##..',
        '..#.###....',
    ],
    取: [
        '######.....',
        '.#..#.#####',
        '.####.....#',
        '.#..#.#...#',
        '.#..#.#...#',
        '.####..#.#.',
        '.#..#..#.#.',
        '.#..#...#..',
        '.####..##..',
        '##..#.#..#.',
        '....##....#',
    ],
    聚: [
        '###########',
        '.#..#.....#',
        '.####.#...#',
        '.#..#.#..#.',
        '.####..##..',
        '##..#.#..#.',
        '....##....#',
        '..#..#..#..',
        '..#..#..#..',
        '.#.#.#.#.#.',
        '#....#....#',
    ],
    焦: [
        '...#...#...',
        '..########.',
        '..#...#....',
        '.#########.',
        '#.#...#....',
        '..########.',
        '..#...#....',
        '..########.',
        '...........',
        '.#.#..#..#.',
        '#...#..#..#',
    ],
    跟: [
        '####.######',
        '#..#.#....#',
        '#..#.######',
        '####.#....#',
        '..#..#....#',
        '..#..######',
        '#.##.#.#...',
        '#.#..#.#..#',
        '#.#..#..#.#',
        '#.#..#...#.',
        '########..#',
    ],
    隨: [
        '####...#...',
        '#.#.#######',
        '#.#...#....',
        '##.#.######',
        '#.#.#...#..',
        '#.#..######',
        '#.###.#...#',
        '#.#.#.#####',
        '##..#.#...#',
        '#..#.#.....',
        '#.#...#####',
    ],
    停: [
        '..#...#....',
        '..#########',
        '.#..#....#.',
        '.#..######.',
        '##.........',
        '.#.########',
        '.#.#......#',
        '.#..#######',
        '.#.....#...',
        '.#.....#...',
        '.#...###...',
    ],
    止: [
        '.....#.....',
        '.....#.....',
        '.....#.....',
        '.#...#.....',
        '.#...#####.',
        '.#...#.....',
        '.#...#.....',
        '.#...#.....',
        '.#...#.....',
        '.#...#.....',
        '###########',
    ],
    中: [
        '.....#.....',
        '.....#.....',
        '###########',
        '#....#....#',
        '#....#....#',
        '#....#....#',
        '###########',
        '.....#.....',
        '.....#.....',
        '.....#.....',
        '.....#.....',
    ],
    沒: [
        '.....#.....',
        '#....#####.',
        '.#...#...#.',
        '....#....#.',
        '#...#..##..',
        '.#.........',
        '....######.',
        '.....#...#.',
        '..#..#..#..',
        '.#....###..',
        '#..###...##',
    ],
    有: [
        '.....#.....',
        '###########',
        '....#......',
        '....#......',
        '...#######.',
        '..##.....#.',
        '##.#######.',
        '...#.....#.',
        '...#######.',
        '...#.....#.',
        '...#....##.',
    ],
    個: [
        '..#.#######',
        '..#.#..#..#',
        '.#..#..#..#',
        '.#..#######',
        '##..#..#..#',
        '.#..#.###.#',
        '.#..#.#.#.#',
        '.#..#.#.#.#',
        '.#..#.###.#',
        '.#..#.....#',
        '.#..#######',
    ],
    轉: [
        '..#....#...',
        '###########',
        '..#.#..#..#',
        '###########',
        '#.#.#..#..#',
        '###########',
        '#.#.#..#.#.',
        '###########',
        '..#......#.',
        '####.#...#.',
        '..#...#.##.',
    ],
    架: [
        '..#....####',
        '######.#..#',
        '..#..#.#..#',
        '..#..#.#..#',
        '.#...#.#..#',
        '#..##..####',
        '.....#.....',
        '###########',
        '....##.#...',
        '..##.#..#..',
        '##...#...##',
    ],
    範: [
        '.#....#....',
        '.####.#####',
        '#..#.#..#..',
        '######.####',
        '#.#..#.#..#',
        '######.#..#',
        '#.#..#.#..#',
        '######.#.##',
        '..#....#...',
        '######.#..#',
        '..#....####',
    ],
    本: [
        '.....#.....',
        '.....#.....',
        '###########',
        '.....#.....',
        '....###....',
        '...#.#.#...',
        '..#..#..#..',
        '.#...#...#.',
        '#..#####..#',
        '.....#.....',
        '.....#.....',
    ],
    月: [
        '.#########',
        '.#.......#',
        '.#.......#',
        '.#########',
        '.#.......#',
        '.#.......#',
        '.#########',
        '.#.......#',
        '.#.......#',
        '#........#',
        '#......###',
    ],
    台: [
        '...#.......',
        '...#...#...',
        '..#.....#..',
        '.#.......#.',
        '###########',
        '..........#',
        '..#######..',
        '..#.....#..',
        '..#.....#..',
        '..#.....#..',
        '..#######..',
    ],
    完: [
        '.....#.....',
        '###########',
        '#.........#',
        '#.#######.#',
        '...........',
        '...........',
        '.#########.',
        '...#..#....',
        '...#..#....',
        '..#...#...#',
        '##....#####',
    ],
    成: [
        '......#..#.',
        '.##########',
        '.#....#....',
        '.#....#..#.',
        '.####.#..#.',
        '.#..#.#.#..',
        '.#..#.#.#..',
        '.#..#..#...',
        '.#.##..#..#',
        '#.....#.#.#',
        '#...##...##',
    ],
    要: [
        '###########',
        '....#.#....',
        '.#########.',
        '.#..#.#..#.',
        '.#########.',
        '....#......',
        '###########',
        '...#....#..',
        '..##...#...',
        '....###....',
        '.###...###.',
    ],
    加: [
        '..#........',
        '..#....####',
        '######.#..#',
        '..#..#.#..#',
        '..#..#.#..#',
        '..#..#.#..#',
        '.#...#.#..#',
        '.#...#.#..#',
        '#....#.#..#',
        '#...#..#..#',
        '..##...####',
    ],
    至: [
        '###########',
        '....#......',
        '...#...#...',
        '..#.....#..',
        '.#########.',
        '.....#....#',
        '.....#.....',
        '..#######..',
        '.....#.....',
        '.....#.....',
        '###########',
    ],
    附: [
        '###..#...#.',
        '#.#..#...#.',
        '#.#.#.#####',
        '##.##....#.',
        '#.#.#....#.',
        '#.#.#.#..#.',
        '#.#.#..#.#.',
        '#.#.#....#.',
        '##..#....#.',
        '#...#....#.',
        '#...#...##.',
    ],
    近: [
        '.#......##.',
        '..#..###...',
        '.....#.....',
        '#....#.....',
        '.#...######',
        '.....#..#..',
        '###.#...#..',
        '..#.#...#..',
        '..#.....#..',
        '.#.#.......',
        '#...#######',
    ],
    消: [
        '.......#...',
        '#...#..#..#',
        '.#...#.#.#.',
        '.......#...',
        '#...#######',
        '.#..#.....#',
        '....#######',
        '....#.....#',
        '..#.#######',
        '.#..#.....#',
        '#...#....##',
    ],
    其: [
        '...#...#...',
        '###########',
        '...#...#...',
        '...#####...',
        '...#...#...',
        '...#####...',
        '...#...#...',
        '###########',
        '...........',
        '..##...##..',
        '##.......##',
    ],
    他: [
        '..#...#....',
        '..#.#.#.##.',
        '.#..#.##.#.',
        '.#..###..#.',
        '##.##.#..#.',
        '.#..#.#..#.',
        '.#..#.#.##.',
        '.#..#.#....',
        '.#..#.#...#',
        '.#..#.....#',
        '.#..#######',
    ],
    來: [
        '.....#.....',
        '###########',
        '.....#.....',
        '..#..#..#..',
        '..#..#..#..',
        '.#.#.#.#.#.',
        '#....#....#',
        '....###....',
        '..##.#.##..',
        '##...#...##',
        '.....#.....',
    ],
    自: [
        '...#.....',
        '#########',
        '#.......#',
        '#.......#',
        '#########',
        '#.......#',
        '#.......#',
        '#########',
        '#.......#',
        '#.......#',
        '#########',
    ],
    設: [
        '###..####..',
        '.....#..#..',
        '###..#..#..',
        '.....#..#.#',
        '###.#...###',
        '...........',
        '....######.',
        '###..#...#.',
        '#.#..#..#..',
        '#.#...###..',
        '###.##...##',
    ],
    樣: [
        '..#..#..#..',
        '..#.#######',
        '####...#...',
        '..#..######',
        '..#....#...',
        '.##.######.',
        '.##...#...#',
        '#.#.##.#.#.',
        '#.#..#.##..',
        '..#.#..#.#.',
        '..##..##..#',
    ],
    式: [
        '.......#..#',
        '.......#..#',
        '###########',
        '.......#...',
        '........#..',
        '.#####..#..',
        '...#....#..',
        '...#.....#.',
        '...#.....#.',
        '...####...#',
        '###.......#',
    ],
    碎: [
        '.......#...',
        '###########',
        '..#..#...#.',
        '..#..#...#.',
        '..#.#.#.#.#',
        '.###...#..#',
        '##.#...#...',
        '.#.########',
        '.#.#...#...',
        '.#.#...#...',
        '.###...#...',
    ],
    石: [
        '###########',
        '.....#.....',
        '.....#.....',
        '.....#.....',
        '....#......',
        '...#######.',
        '..##.....#.',
        '##.#.....#.',
        '...#.....#.',
        '...#.....#.',
        '...#######.',
    ],
    床: [
        '......#....',
        '.##########',
        '.#....#....',
        '.#....#....',
        '.##########',
        '.#....#....',
        '.#....##...',
        '.#...##.#..',
        '#...#.#..#.',
        '#.##..#...#',
        '......#....',
    ],
    板: [
        '..#..######',
        '..#..#.....',
        '####.#.....',
        '..#..#####.',
        '..#..#...#.',
        '.##..#...#.',
        '.##.#..#.#.',
        '#.#.#..#.#.',
        '#.#.....#..',
        '..#...##.#.',
        '..#.##....#',
    ],
    電: [
        '.#########.',
        '.....#.....',
        '###########',
        '#..#.#.#..#',
        '.#########.',
        '.#...#...#.',
        '.#########.',
        '.#...#...#.',
        '.#########.',
        '.....#....#',
        '.....######',
    ],
    氣: [
        '.#.........',
        '.##########',
        '.#.........',
        '#..######..',
        '...........',
        '##########.',
        '..#.#.#..#.',
        '....#....#.',
        '########.#.',
        '..#.#.#...#',
        '##..#..#..#',
    ],
    化: [
        '...#..#....',
        '...#..#....',
        '..#...#...#',
        '..#...#..#.',
        '.##...#.#..',
        '#.#...##...',
        '..#...#....',
        '..#...#....',
        '..#...#...#',
        '..#...#...#',
        '..#....####',
    ],
    路: [
        '####..#....',
        '#..#..####.',
        '#..#.#...#.',
        '#####.#.#..',
        '..#....#...',
        '..#...#.#..',
        '#.##.#...##',
        '#.#.######.',
        '#.#..#...#.',
        '#.#..#...#.',
        '####.#####.',
    ],
    基: [
        '...#...#...',
        '.#########.',
        '...#...#...',
        '...#####...',
        '...#...#...',
        '###########',
        '...#...#...',
        '..#..#..#..',
        '##.#####.##',
        '.....#.....',
        '.#########.',
    ],
    寬: [
        '.....#.....',
        '###########',
        '#..#...#..#',
        '.#########.',
        '..#......#.',
        '..########.',
        '..#......#.',
        '..########.',
        '....#.#.#..',
        '..##..#...#',
        '##....#####',
    ],
    吸: [
        '...#######.',
        '###..#...#.',
        '#.#..#..#..',
        '#.#..#.#...',
        '#.#..#.###.',
        '#.#.#....#.',
        '#.#.#.#..#.',
        '#.##...#.#.',
        '#.#.....#..',
        '###...##.#.',
        '....##....#',
    ],
    距: [
        '#####.#####',
        '#...#.#....',
        '#...#.#....',
        '#####.#####',
        '..#...#...#',
        '..#...#...#',
        '#.###.#####',
        '#.#...#....',
        '#.#...#....',
        '#.#...#....',
        '#####.#####',
    ],
    離: [
        '...#...#.#.',
        '######.#.#.',
        '..#.#.#####',
        '#..#..#..#.',
        '#.#.#.#####',
        '#######..#.',
        '...#..#..#.',
        '###########',
        '#.#...#..#.',
        '#.###.#..#.',
        '#....######',
    ],
    小: [
        '.....#.....',
        '.....#.....',
        '.....#.....',
        '.#...#...#.',
        '.#...#...#.',
        '.#...#....#',
        '#....#....#',
        '#....#....#',
        '.....#.....',
        '.....#.....',
        '...###.....',
    ],
    大: [
        '.....#.....',
        '.....#.....',
        '.....#.....',
        '###########',
        '.....#.....',
        '.....#.....',
        '....#.#....',
        '....#.#....',
        '...#...#...',
        '..#.....#..',
        '##.......##',
    ],
    型: [
        '######.#..#',
        '.#..#..#..#',
        '.#..#..#..#',
        '######.#..#',
        '.#..#..#..#',
        '#...#....##',
        '.....#.....',
        '..#######..',
        '.....#.....',
        '.....#.....',
        '###########',
    ],
    面: [
        '###########',
        '.....#.....',
        '....#......',
        '###########',
        '#..#...#..#',
        '#..#####..#',
        '#..#...#..#',
        '#..#####..#',
        '#..#...#..#',
        '#..#...#..#',
        '###########',
    ],
    上: [
        '....#......',
        '....#......',
        '....#......',
        '....#......',
        '....######.',
        '....#......',
        '....#......',
        '....#......',
        '....#......',
        '....#......',
        '###########',
    ],
    接: [
        '.#.....#...',
        '.#..#######',
        '###..#...#.',
        '.#...#...#.',
        '.#.########',
        '.#....#....',
        '.#.########',
        '###..#...#.',
        '.#..##...#.',
        '.#....###..',
        '##..##...##',
    ],
    頭: [
        '####.######',
        '.......#...',
        '####.######',
        '#..#.#....#',
        '#..#.######',
        '#..#.#....#',
        '####.######',
        '.#...#....#',
        '.#.#.######',
        '.#.#..#..#.',
        '######....#',
    ],
    號: [
        '####...####',
        '#..#...#...',
        '#..#.######',
        '####.#.#..#',
        '.....#####.',
        '######.#...',
        '.#...#.####',
        '####.#...#.',
        '#..#...#.#.',
        '...#...#.#.',
        '.##..##..##',
    ],
    區: [
        '###########',
        '#..........',
        '#...####...',
        '#...#..#...',
        '#...####...',
        '#..........',
        '#.####.###.',
        '#.#..#.#.#.',
        '#.####.###.',
        '#..........',
        '.##########',
    ],
    段: [
        '..##.####..',
        '##...#..#..',
        '#....#..#..',
        '####.#..#.#',
        '#...#...###',
        '####.......',
        '#...######.',
        '#....#...#.',
        '####.#..#..',
        '#.....###..',
        '#..###...##',
    ],
    靠: [
        '..#..#.....',
        '..########.',
        '.#...#.....',
        '###########',
        '..#.....#..',
        '###########',
        '....#.#....',
        '.####.####.',
        '....#.#....',
        '####..#####',
        '...#..#....',
    ],
    視: [
        '..#..######',
        '..#..#....#',
        '####.######',
        '...#.#....#',
        '...#.######',
        '..#..#....#',
        '.##..######',
        '#.##..#.#..',
        '..#...#.#..',
        '..#..#..#.#',
        '..###...###',
    ],
    統: [
        '..#....#...',
        '.#..#######',
        '#..#..#....',
        '####..#..#.',
        '..#..#...#.',
        '.#...####.#',
        '#####.#.#.#',
        '..#...#.#..',
        '#.#...#.#..',
        '#.#..#..#.#',
        '..###...###',
    ],
    計: [
        '####....#..',
        '........#..',
        '####....#..',
        '.....######',
        '####....#..',
        '........#..',
        '........#..',
        '####....#..',
        '#..#....#..',
        '#..#....#..',
        '####....#..',
    ],
    新: [
        '..#......##',
        '#####.###..',
        '.#..#.#....',
        '.#..#.#....',
        '###########',
        '..#...#..#.',
        '#####.#..#.',
        '..##..#..#.',
        '.##.#.#..#.',
        '#.#..#...#.',
        '..#..#...#.',
    ],
    增: [
        '.#...#..#..',
        '.#.########',
        '.#.#...#..#',
        '####.#.##.#',
        '.#.#...#..#',
        '.#.########',
        '.#..#....#.',
        '.#..######.',
        '.#..#....#.',
        '###.#....#.',
        '....######.',
    ],
    片: [
        '.#...#....',
        '.#...#....',
        '.#...#....',
        '.#########',
        '.#........',
        '.#........',
        '.#######..',
        '.#.....#..',
        '.#.....#..',
        '#......#..',
        '#......#..',
    ],
    需: [
        '.#########.',
        '.....#.....',
        '###########',
        '#.#..#.#..#',
        '...#.#..#..',
        '###########',
        '....#......',
        '.#########.',
        '.#..#.#..#.',
        '.#..#.#..#.',
        '.#..#.#.##.',
    ],
    少: [
        '.....#.....',
        '.....#.....',
        '..#..#..#..',
        '..#..#...#.',
        '.#...#....#',
        '#....#.....',
        '....##...#.',
        '........#..',
        '......##...',
        '....##.....',
        '.###.......',
    ],
    才: [
        '.......#...',
        '.......#...',
        '###########',
        '.......#...',
        '......##...',
        '.....#.#...',
        '....#..#...',
        '..##...#...',
        '##.....#...',
        '.......#...',
        '.....###...',
    ],
    能: [
        '.#....#..##',
        '#...#.###..',
        '#####.#....',
        '......#...#',
        '#####.#####',
        '#...#......',
        '#####.#..##',
        '#...#.###..',
        '#####.#....',
        '#...#.#...#',
        '#..##.#####',
    ],
    '。': ['.##.', '#..#', '#..#', '.##.'],
    解: [
        '.###.######',
        '#..#...#..#',
        '..#...#...#',
        '######..##.',
        '#.#.#.#.#..',
        '#####.#####',
        '#.#.#.#.#..',
        '#.#.#...#..',
        '#####.#####',
        '#...#...#..',
        '#..##...#..',
    ],
    析: [
        '..#.....##.',
        '..#..###...',
        '####.#.....',
        '..#..#.....',
        '..#..######',
        '.##..#...#.',
        '.##..#...#.',
        '#.#..#...#.',
        '#.#.#....#.',
        '..#.#....#.',
        '..#......#.',
    ],
    失: [
        '..#..#.....',
        '..#..#.....',
        '..########.',
        '.#...#.....',
        '#....#.....',
        '###########',
        '.....#.....',
        '....#.#....',
        '...#...#...',
        '..#.....#..',
        '##.......##',
    ],
    敗: [
        '#####.#....',
        '#...#.#####',
        '#####.#..#.',
        '#...#.#..#.',
        '#####....#.',
        '#...#..#.#.',
        '#...#..#.#.',
        '#####...#..',
        '........#..',
        '.#.#..##.#.',
        '#...##....#',
    ],
    案: [
        '.....#.....',
        '###########',
        '#...#.....#',
        '###########',
        '...#....#..',
        '...#####...',
        '..#..#..#..',
        '###########',
        '....##.#...',
        '..##.#..#..',
        '##...#...##',
    ],
    缺: [
        '#......#...',
        '###########',
        '#.#....#..#',
        '..#....#..#',
        '#####..#..#',
        '..#..######',
        '..#....#...',
        '#.#.#..#...',
        '#.#.#.#.#..',
        '#.#.##...#.',
        '#####.....#',
    ],
    在: [
        '....#......',
        '###########',
        '...#...#...',
        '...#...#...',
        '..#....#...',
        '..#.#######',
        '.##....#...',
        '#.#....#...',
        '..#....#...',
        '..#....#...',
        '..#.#######',
    ],
    按: [
        '.#....#....',
        '.#.########',
        '####......#',
        '.#.#..#...#',
        '.#....#....',
        '.#.########',
        '.##..#...#.',
        '##...#...#.',
        '.#..##..#..',
        '.#....###..',
        '##.###...##',
    ],
    下: [
        '###########',
        '....#......',
        '....#......',
        '....##.....',
        '....#.##...',
        '....#...##.',
        '....#......',
        '....#......',
        '....#......',
        '....#......',
        '....#......',
    ],
    立: [
        '.....#.....',
        '.....#.....',
        '###########',
        '...........',
        '...#....#..',
        '...#....#..',
        '...#....#..',
        '...#...#...',
        '...#...#...',
        '.......#...',
        '###########',
    ],
    一: ['###########'],
    請: [
        '###....#...',
        '....#######',
        '###....#...',
        '.....######',
        '###....#...',
        '....#######',
        '.....#....#',
        '###..######',
        '#.#..#....#',
        '#.#..######',
        '###..#....#',
    ],
    先: [
        '..#..#.....',
        '..#..#.....',
        '..########.',
        '.#...#.....',
        '#....#.....',
        '###########',
        '...#..#....',
        '...#..#....',
        '...#..#....',
        '..#...#...#',
        '##.....####',
    ],
    將: [
        '#..#...####',
        '#..#.##...#',
        '#..#...#.#.',
        '####.#..#..',
        '...#..##.#.',
        '...###...#.',
        '####.######',
        '.#.#.....#.',
        '.#.#.#...#.',
        '#..#..#..#.',
        '#..#....##.',
    ],
    巢: [
        '.#...#...#.',
        '#...#...#..',
        '.#...#...#.',
        '..#######..',
        '..#..#..#..',
        '..#######..',
        '..#..#..#..',
        '###########',
        '....##.#...',
        '..##.#..#..',
        '##...#...##',
    ],
    狀: [
        '#..#...#.#.',
        '#..#...#..#',
        '#..#...#...',
        '###########',
        '...#...#...',
        '...#...#...',
        '####...#...',
        '.#.#..#.#..',
        '.#.#..#.#..',
        '#..#.#...#.',
        '#..##.....#',
    ],
    包: [
        '..#........',
        '..########.',
        '.#.......#.',
        '.######..#.',
        '#.#...#..#.',
        '#.#...#..#.',
        '..#####..#.',
        '..#....##..',
        '..#........',
        '..#.......#',
        '..#########',
    ],
    含: [
        '...#####...',
        '..#.....#..',
        '.#.#####.#.',
        '#.........#',
        '..#######..',
        '.......#...',
        '......#....',
        '.#########.',
        '.#.......#.',
        '.#.......#.',
        '.#########.',
    ],
    合: [
        '....###....',
        '...#...#...',
        '..#.....#..',
        '.#.#####.#.',
        '#.........#',
        '...........',
        '..#######..',
        '..#.....#..',
        '..#.....#..',
        '..#.....#..',
        '..#######..',
    ],
    併: [
        '..#..#...#.',
        '..#..#..#..',
        '.#.########',
        '.#...#...#.',
        '##...#...#.',
        '.#...#...#.',
        '.#.########',
        '.#...#...#.',
        '.#...#...#.',
        '.#..#....#.',
        '.#..#....#.',
    ],
    扁: [
        '.##########',
        '.#.........',
        '.#########.',
        '.#.......#.',
        '.#########.',
        '.#.........',
        '.##########',
        '.##..#.#..#',
        '#.#########',
        '#.#..#.#..#',
        '..#..#.#.##',
    ],
    平: [
        '###########',
        '.....#.....',
        '.#...#...#.',
        '..#..#..#..',
        '.....#.....',
        '.....#.....',
        '###########',
        '.....#.....',
        '.....#.....',
        '.....#.....',
        '.....#.....',
    ],
    展: [
        '.##########',
        '.#........#',
        '.##########',
        '.#..#...#..',
        '.##########',
        '.#..#...#..',
        '.#..#...#..',
        '.##########',
        '#..#..#..#.',
        '#..#...##..',
        '..####...##',
    ],
    為: [
        '...#..#....',
        '...#.#.....',
        '.########..',
        '....#...#..',
        '...#######.',
        '..#......#.',
        '.##########',
        '#.........#',
        '.#.#.#.#..#',
        '.#.#.#.#..#',
        '........##.',
    ],
    別: [
        '#####.....#',
        '#...#..#..#',
        '#...#..#..#',
        '#####..#..#',
        '.#.....#..#',
        '.####..#..#',
        '.#..#..#..#',
        '#...#..#..#',
        '#...#.....#',
        '....#.....#',
        '.###.....##',
    ],
    反: [
        '.##########',
        '.#.........',
        '.#.........',
        '.#########.',
        '.#.......#.',
        '.#..#....#.',
        '.#..#...#..',
        '#....#..#..',
        '#.....##...',
        '....##..#..',
        '.###.....##',
    ],
    子: [
        '..#######..',
        '........#..',
        '.......#...',
        '......#....',
        '.....#.....',
        '###########',
        '.....#.....',
        '.....#.....',
        '.....#.....',
        '.....#.....',
        '...###.....',
    ],
    順: [
        '.#...######',
        '.#.#...#...',
        '.#.#.######',
        '.#.#.#....#',
        '.#.#.######',
        '.#.#.#....#',
        '.#.#.######',
        '.#.#.#....#',
        '.#.#.######',
        '#.....#..#.',
        '#...##....#',
    ],
    序: [
        '......#....',
        '.##########',
        '.#.........',
        '.#..######.',
        '.#......#..',
        '.#...#.#...',
        '.#.########',
        '.#.....#..#',
        '#......#.#.',
        '#......#...',
        '.....###...',
    ],
    點: [
        '#####..#...',
        '#.#.#..#...',
        '##.##..####',
        '#...#..#...',
        '#.#.#..#...',
        '#####..#...',
        '..#...#####',
        '#####.#...#',
        '......#...#',
        '#.#.#.#...#',
        '#.#.#.#####',
    ],
    擊: [
        '...#..####.',
        '######...#.',
        '.#.#.######',
        '.#####.#.#.',
        '.#.#.#.##..',
        '#######..##',
        '.....#.....',
        '..#######..',
        '.....#.....',
        '###########',
        '.....#.....',
    ],
    以: [
        '.#.......#.',
        '.#..#....#.',
        '.#...#...#.',
        '.#....#..#.',
        '.#.......#.',
        '.#.......#.',
        '.#......#..',
        '.#..##..#..',
        '.###...#.#.',
        '##....#...#',
        '....##....#',
    ],
    重: [
        '.#########.',
        '.....#.....',
        '###########',
        '..#..#..#..',
        '..#######..',
        '..#..#..#..',
        '..#######..',
        '.....#.....',
        '.#########.',
        '.....#.....',
        '###########',
    ],
    命: [
        '....###....',
        '...#...#...',
        '..#.....#..',
        '.#.#####.#.',
        '#.........#',
        '.####.####.',
        '.#..#.#..#.',
        '.#..#.#..#.',
        '.#..#.#..#.',
        '.####.#.##.',
        '......#....',
    ],
    名: [
        '.....#.....',
        '....######.',
        '...#.....#.',
        '.##.#...#..',
        '.....#.#...',
        '......#....',
        '....#######',
        '..###.....#',
        '##..#.....#',
        '....#.....#',
        '....#######',
    ],
    直: [
        '.....#.....',
        '###########',
        '.....#.....',
        '..#######..',
        '..#.....#..',
        '..#######..',
        '..#.....#..',
        '..#######..',
        '..#.....#..',
        '..#.....#..',
        '###########',
    ],
    瀏: [
        '...##.###.#',
        '#..#..#.#.#',
        '.#.#.##.#.#',
        '...##...#.#',
        '#...###.#.#',
        '.#.#...##.#',
        '..#.###.#.#',
        '.....#..#.#',
        '..#.###...#',
        '.#.#.#.#..#',
        '#..#####.##',
    ],
    裡: [
        '.#..#######',
        '.#..#..#..#',
        '###.#######',
        '..#.#..#..#',
        '.#..#..#..#',
        '.##.#######',
        '##.....#...',
        '.##.#######',
        '.#.....#...',
        '.#.....#...',
        '.#..#######',
    ],
    就: [
        '..#....#.#.',
        '#####..#..#',
        '.....######',
        '#####..#...',
        '#...#..#...',
        '#...#..##..',
        '#####.#.#..',
        '..#...#.#..',
        '#.##..#.#.#',
        '#.#..#..#.#',
        '.##..#..###',
    ],
    使: [
        '..#....#...',
        '..#.#######',
        '.#.....#...',
        '.#..#######',
        '##..#..#..#',
        '.#..#..#..#',
        '.#..#######',
        '.#...#.#...',
        '.#....##...',
        '.#...#..#..',
        '.#.##....##',
    ],
    用: [
        '.##########',
        '.#...#....#',
        '.#...#....#',
        '.##########',
        '.#...#....#',
        '.#...#....#',
        '.##########',
        '.#...#....#',
        '.#...#....#',
        '#....#....#',
        '#....#..###',
    ],
    俯: [
        '..#...#....',
        '..#########',
        '.#.#..#..#.',
        '.#.#..#..#.',
        '##.#.######',
        '.#.###...#.',
        '.#.#.#.#.#.',
        '.#.#.#..##.',
        '.#.#.#...#.',
        '.##..#...#.',
        '.#...#..##.',
    ],
    鐵: [
        '..##.#..#.#',
        '.#..###.#.#',
        '#....#..#..',
        '###########',
        '..#.#.#.#..',
        '###.#.#.#.#',
        '..#######.#',
        '#.#..#...#.',
        '#.#.###..#.',
        '..#..#..#.#',
        '########..#',
    ],
    模: [
        '..#...#..#.',
        '..#.#######',
        '####..#..#.',
        '..#..######',
        '..#..#....#',
        '.##..######',
        '.###.#....#',
        '#.#.#######',
        '#.#....#...',
        '..#...#..#.',
        '..#.##....#',
    ],
    擬: [
        '.#.#..#####',
        '.#.###...#.',
        '####....#..',
        '.#..#######',
        '.#.#....#.#',
        '.#.####.#..',
        '.##.#...#..',
        '##.####.###',
        '.#..#.#.#..',
        '.#.#.##.#..',
        '###...#####',
    ],
    由: [
        '.....#.....',
        '.....#.....',
        '###########',
        '#....#....#',
        '#....#....#',
        '#....#....#',
        '###########',
        '#....#....#',
        '#....#....#',
        '#....#....#',
        '###########',
    ],
    教: [
        '..#..#.#...',
        '######.####',
        '..#.#.#..#.',
        '..#.#.#..#.',
        '######...#.',
        '.#.....#.#.',
        '#.###..#.#.',
        '....#...#..',
        '######..#..',
        '...#...#.#.',
        '..##.##...#',
    ],
    學: [
        '.##..#..##.',
        '.#..#.#..#.',
        '.###.#.###.',
        '.#..#.#..#.',
        '###########',
        '#.........#',
        '#..#####..#',
        '......#....',
        '###########',
        '.....#.....',
        '...###.....',
    ],
    製: [
        '#..#...#..#',
        '######.#..#',
        '#..#...#..#',
        '######.#..#',
        '#..#.#...##',
        '...#.......',
        '###########',
        '...#.#...#.',
        '###...#..#.',
        '..#....##..',
        '.#####...##',
    ],
    作: [
        '..#..#.....',
        '..#..######',
        '.#...#.#...',
        '.#..#..#...',
        '##..#..####',
        '.#.....#...',
        '.#.....#...',
        '.#.....####',
        '.#.....#...',
        '.#.....#...',
        '.#.....#...',
    ],
    造: [
        '.#..#..#...',
        '..#.######.',
        '....#..#...',
        '#......#...',
        '.#.########',
        '...........',
        '###..#####.',
        '..#..#...#.',
        '..#..#####.',
        '.#.#.......',
        '#...#######',
    ],
    系: [
        '.#########.',
        '....#......',
        '...#...#...',
        '..#...#....',
        '...#.#..#..',
        '....#....#.',
        '###########',
        '.....#.....',
        '..#..#..#..',
        '.#...#...#.',
        '#....#....#',
    ],
    但: [
        '..#..######',
        '..#..#....#',
        '.#...#....#',
        '.#...######',
        '##...#....#',
        '.#...#....#',
        '.#...#....#',
        '.#...######',
        '.#.........',
        '.#.........',
        '.#..#######',
    ],
    不: [
        '###########',
        '.......#...',
        '......#....',
        '.....#.....',
        '....##.#...',
        '..##.#..#..',
        '##...#...#.',
        '.....#....#',
        '.....#.....',
        '.....#.....',
        '.....#.....',
    ],
    '，': ['.##', '.##', '##.'],
    分: [
        '..#..####..',
        '..#.....#..',
        '..#......#.',
        '.#.......#.',
        '.#........#',
        '#.#######.#',
        '#...#...#..',
        '....#...#..',
        '...#....#..',
        '...#....#..',
        '.##...##...',
    ],
    想: [
        '..#...#####',
        '#####.#...#',
        '..#...#####',
        '..##..#...#',
        '.##.#.#####',
        '#.#...#...#',
        '..#...#####',
        '.....#.....',
        '...#..#..#.',
        '.#.#......#',
        '#...#####..',
    ],
    '？': [
        '..###..',
        '.#...#.',
        '#.....#',
        '......#',
        '.....#.',
        '....#..',
        '...#...',
        '...#...',
        '.......',
        '...#...',
        '...#...',
    ],
    問: [
        '#####.#####',
        '#...#.#...#',
        '#####.#####',
        '#...#.#...#',
        '#####.#####',
        '#.........#',
        '#..#####..#',
        '#..#...#..#',
        '#..#...#..#',
        '#..#####..#',
        '#........##',
    ],
    題: [
        '#####.#####',
        '#...#...#..',
        '#####.#####',
        '#...#.#...#',
        '#####.#####',
        '......#...#',
        '#####.#####',
        '..#....#.#.',
        '#.###.#...#',
        '###........',
        '#..########',
    ],
    '！': ['#', '#', '#', '#', '#', '#', '#', '.', '.', '#', '#'],
    與: [
        '...###.....',
        '.##.#..###.',
        '.#..#....#.',
        '.##.###.##.',
        '.#....#..#.',
        '.##.#.#.##.',
        '.#..#.#..#.',
        '###########',
        '...........',
        '..#.....#..',
        '##.......##',
    ],
    施: [
        '.#...#.....',
        '.#...######',
        '#####..#...',
        '.#..#..#.##',
        '.#...#.##.#',
        '.###.###..#',
        '.#.###.#..#',
        '#..#.#.#.##',
        '#..#.#.#...',
        '...#.#....#',
        '.##...#####',
    ],
    工: [
        '.#########.',
        '.....#.....',
        '.....#.....',
        '.....#.....',
        '.....#.....',
        '.....#.....',
        '.....#.....',
        '.....#.....',
        '###########',
    ],
    運: [
        '#..########',
        '.#.#...#..#',
        '....#######',
        '#...#..#..#',
        '.#..#######',
        '....#..#..#',
        '###.#######',
        '..#....#...',
        '..#.#######',
        '.#.#...#...',
        '#...#######',
    ],
    行: [
        '..#..#####.',
        '.#.........',
        '#..........',
        '...........',
        '..#.#######',
        '.#......#..',
        '##......#..',
        '.#......#..',
        '.#......#..',
        '.#......#..',
        '.#....###..',
    ],
    親: [
        '..#...#####',
        '#####.#...#',
        '.#..#.#####',
        '.#..#.#...#',
        '###########',
        '..#...#...#',
        '#####.#####',
        '..##...#.#.',
        '.##.#..#.#.',
        '#.#...#..#.',
        '..#.##...##',
    ],
    駕: [
        '..#....####',
        '######.#..#',
        '..#..#.#..#',
        '.##########',
        '#.#..#.....',
        '..########.',
        '..#..#.....',
        '..#########',
        '..........#',
        '.#.#.#.#..#',
        '#..#.#.#.##',
    ],
    駛: [
        '#####...#..',
        '#.#..######',
        '####.#..#.#',
        '#.#..#..#.#',
        '####.#..#.#',
        '#.#..######',
        '#####...#..',
        '....#.#.#..',
        '#.#.#..#...',
        '#...#.#.#..',
        '..##.#...##',
    ],
    也: [
        '.....#.....',
        '..#..#..##.',
        '..#..###.#.',
        '..####...#.',
        '###..#...#.',
        '..#..#...#.',
        '..#..#..##.',
        '..#..#.....',
        '..#..#....#',
        '..#.......#',
        '...########',
    ],
    靈: [
        '.#########.',
        '.....#.....',
        '###########',
        '#.#..#.#..#',
        '...#.#..#..',
        '.#########.',
        '.#..#.#..#.',
        '###########',
        '..#..#..#..',
        '.#.#.#.#.#.',
        '###########',
    ],
    活: [
        '........###',
        '#...####...',
        '.#.....#...',
        '.......#...',
        '#...#######',
        '.#.....#...',
        '.......#...',
        '....#######',
        '..#.#.....#',
        '.#..#.....#',
        '#...#######',
    ],
    滑: [
        '....######.',
        '#...#....#.',
        '.#..#.####.',
        '....#.#..#.',
        '#..########',
        '.#.#......#',
        '....######.',
        '....#....#.',
        '..#.######.',
        '.#..#....#.',
        '#...#...##.',
    ],
    導: [
        '.#...#..#..',
        '..#.#######',
        '#.....#....',
        '.#..######.',
        '....#....#.',
        '###.######.',
        '..#.#....#.',
        '###########',
        '........#..',
        '..#.....#..',
        '...#..###..',
    ],
    雲: [
        '.#########.',
        '.....#.....',
        '###########',
        '#.#..#.#..#',
        '#..#.#..#.#',
        '.....#.....',
        '.#########.',
        '...........',
        '###########',
        '..#.....#..',
        '.#######.#.',
    ],
    端: [
        '.#..#..#..#',
        '.#..#..#..#',
        '###########',
        '..#........',
        '#.#.#######',
        '#.#....#...',
        '#.#.#######',
        '#.#.#.#.#.#',
        '..#.#.#.#.#',
        '#####.#.#.#',
        '....#....##',
    ],
    儲: [
        '..####..#..',
        '..#....####',
        '.#.###..#..',
        '.#......#.#',
        '##.###.####',
        '.#......#..',
        '.#.....####',
        '.#.#####..#',
        '.#.#.#.####',
        '.#.#.#.#..#',
        '.#.###.####',
    ],
    存: [
        '....#......',
        '###########',
        '...#.......',
        '...#.#####.',
        '..#......#.',
        '.#......#..',
        '##.....#...',
        '.#.########',
        '.#.....#...',
        '.#.....#...',
        '.#....##...',
    ],
    發: [
        '#####.#..#.',
        '....#.#.#..',
        '.#.#...#..#',
        '..#....#.#.',
        '#####.####.',
        '....#.#..##',
        '#####......',
        '#....######',
        '#####.#..#.',
        '....#..###.',
        '.###.##...#',
    ],
    聯: [
        '####.#...#.',
        '#.#.#.#.#.#',
        '###..#...#.',
        '#.#.#.#.#.#',
        '#.#.###.###',
        '###...#.#..',
        '#.#.#.#.#.#',
        '#.#.#.#.#.#',
        '###.###.###',
        '#.#...#.#..',
        '..#.##..#..',
    ],
    掛: [
        '.#...#...#..',
        '.#..####.#..',
        '###..#...#..',
        '.#...#...#..',
        '.#.#####.#..',
        '.#...#...##.',
        '.##..#...#.#',
        '##..####.#..',
        '.#...#...#..',
        '.#...#...#..',
        '##.#####.#..',
    ],
    苗: [
        '...#...#...',
        '###########',
        '...#...#...',
        '...#...#...',
        '.#########.',
        '.#...#...#.',
        '.#...#...#.',
        '.#########.',
        '.#...#...#.',
        '.#...#...#.',
        '.#########.',
    ],
    栗: [
        '###########',
        '....#.#....',
        '.#########.',
        '.#..#.#..#.',
        '.#..#.#..#.',
        '.#########.',
        '.....#.....',
        '###########',
        '....##.#...',
        '..##.#..#..',
        '##...#...##',
    ],
    臨: [
        '.....#.....',
        '####.######',
        '#.#.#......',
        '#.#.#.####.',
        '####..#..#.',
        '#..#..####.',
        '####.......',
        '#.#.###.###',
        '#.#.#.#.#.#',
        '#####.#.#.#',
        '....###.###',
    ],
    時: [
        '.......#...',
        '####.######',
        '#..#...#...',
        '#..#...#...',
        '#..########',
        '####.....#.',
        '#..########',
        '#..#.....#.',
        '#..#.#...#.',
        '####..#..#.',
        '........##.',
    ],
    補: [
        '.#.....#..#',
        '.#..#######',
        '####...#...',
        '...########',
        '..#.#..#..#',
        '.#..#######',
        '###.#..#..#',
        '.#..#######',
        '.##.#..#..#',
        '.#..#..#..#',
        '.#..#..#.##',
    ],
    機: [
        '..#..#.#.#.',
        '..#.#..##.#',
        '####.#.#.#.',
        '..#.#.#.#.#',
        '..#.#######',
        '.##....#.#.',
        '.##.#######',
        '#.#..#..#..',
        '#.#..##.#.#',
        '..#.#....#.',
        '..#.#..##.#',
    ],
    你: [
        '..#.#......',
        '..#.#######',
        '.#..#.....#',
        '.#.#...#..#',
        '##.....#...',
        '.#..#..#.#.',
        '.#..#..#.#.',
        '.#.#...#..#',
        '.#.#...#..#',
        '.#.....#...',
        '.#...###...',
    ],
    該: [
        '###....#...',
        '....#######',
        '###....#...',
        '......#...#',
        '###..#...#.',
        '......#.#..',
        '.......#..#',
        '###..##..#.',
        '#.#.....#..',
        '#.#...##.#.',
        '###.##....#',
    ],
    了: [
        '##########',
        '........#.',
        '.......#..',
        '......#...',
        '.....#....',
        '.....#....',
        '.....#....',
        '.....#....',
        '.....#....',
        '.....#....',
        '...###....',
    ],
    細: [
        '..#..######',
        '.#...#.#..#',
        '#..#.#.#..#',
        '####.#.#..#',
        '..#..#.#..#',
        '.#...######',
        '####.#.#..#',
        '..#..#.#..#',
        '#.##.#.#..#',
        '#.#..#.#..#',
        '..#..######',
    ],
    粒: [
        '..#....#...',
        '#.#....#...',
        '#.#.#######',
        '..#........',
        '####.#...#.',
        '..#..#...#.',
        '.##..#...#.',
        '.###.#..#..',
        '#.#..#..#..',
        '#.#.....#..',
        '..#.#######',
    ],
    刻: [
        '...#......#',
        '######.#..#',
        '...#...#..#',
        '..#....#..#',
        '.#...#.#..#',
        '..#.#..#..#',
        '...#...#..#',
        '.##..#.#..#',
        '....#.....#',
        '..##.#....#',
        '##....#..##',
    ],
    表: [
        '.....#.....',
        '###########',
        '.....#.....',
        '.#########.',
        '.....#.....',
        '###########',
        '....#.#....',
        '..##..#...#',
        '##.#...#.#.',
        '...#....#..',
        '.#####...##',
    ],
    排: [
        '.#....#.#..',
        '.#.####.###',
        '###...#.#..',
        '.#....#.#..',
        '.#..###.###',
        '.#....#.#..',
        '.##...#.#..',
        '##.####.#..',
        '.#....#.###',
        '.#...#..#..',
        '##.##...#..',
    ],
    於: [
        '..#...###..',
        '..#..#...#.',
        '#####.....#',
        '..#........',
        '..#...##...',
        '..###...##.',
        '.#..#......',
        '.#..#......',
        '#...#......',
        '#...#.##...',
        '..##....##.',
    ],
    打: [
        '..#..######',
        '..#.....#..',
        '####....#..',
        '..#.....#..',
        '..#.....#..',
        '..#.....#..',
        '..##....#..',
        '###.....#..',
        '..#.....#..',
        '..#.....#..',
        '.##...###..',
    ],
    回: [
        '###########',
        '#.........#',
        '#.........#',
        '#..#####..#',
        '#..#...#..#',
        '#..#...#..#',
        '#..#...#..#',
        '#..#####..#',
        '#.........#',
        '#.........#',
        '###########',
    ],
    饋: [
        '.###...#...',
        '#...#######',
        '..#.#..#..#',
        '###########',
        '#..#...#...',
        '###########',
        '#..#.#...#.',
        '####.#####.',
        '#....#...#.',
        '#.#..#####.',
        '##.##....##',
    ],
    態: [
        '.#....#..##',
        '#...#.###..',
        '#####.#...#',
        '#...#.#####',
        '#####.#....',
        '#...#.#####',
        '#####.#....',
        '#...#.#####',
        '...#..#....',
        '.#.#.....#.',
        '#...#####.#',
    ],
    果: [
        '.#########.',
        '.#...#...#.',
        '.#########.',
        '.#...#...#.',
        '.#########.',
        '.....#.....',
        '###########',
        '....##.#...',
        '..##.#..#..',
        '##...#...##',
        '.....#.....',
    ],
    畫: [
        '.....#.....',
        '.#########.',
        '.....#...#.',
        '###########',
        '.....#...#.',
        '###########',
        '..#..#..#..',
        '..#######..',
        '..#..#..#..',
        '..#..#..#..',
        '###########',
    ],
    減: [
        '........#.#',
        '#..########',
        '.#.#....#..',
        '...######..',
        '#..#....#.#',
        '.#.#.####.#',
        '...#.#.#.#.',
        '.#.#.###.#.',
        '.#.#.....#.',
        '#.#....##.#',
        '#.#..##...#',
    ],
    這: [
        '.#...#####.',
        '..#........',
        '....#######',
        '#..........',
        '.#...#####.',
        '...........',
        '###..#####.',
        '..#..#...#.',
        '..#..#####.',
        '.#.#.......',
        '#...#######',
    ],
    條: [
        '..#...#....',
        '..#...#####',
        '.#.#.#...#.',
        '.#.##.#..#.',
        '##.#..###..',
        '.#.###.#.##',
        '.#.#...#...',
        '.#.########',
        '.#.#..##...',
        '.#...#.#.#.',
        '.#.##..#..#',
    ],
    通: [
        '.#..######.',
        '..#..#..#..',
        '....#######',
        '#...#..#..#',
        '.#..#######',
        '....#..#..#',
        '###.#######',
        '..#.#..#..#',
        '..#.#..#.##',
        '.#.#.......',
        '#...#######',
    ],
    往: [
        '..#...#....',
        '.#.....#...',
        '#...#######',
        '.......#...',
        '..#....#...',
        '.#.....#...',
        '##..#######',
        '.#.....#...',
        '.#.....#...',
        '.#.....#...',
        '.#..#######',
    ],
    任: [
        '..#.....##.',
        '..#.####...',
        '.#.....#...',
        '.#.....#...',
        '##.....#...',
        '.#.########',
        '.#.....#...',
        '.#.....#...',
        '.#.....#...',
        '.#.....#...',
        '.#..#######',
    ],
    何: [
        '..#.#######',
        '..#......#.',
        '.#.......#.',
        '.#..###..#.',
        '##..#.#..#.',
        '.#..#.#..#.',
        '.#..#.#..#.',
        '.#..###..#.',
        '.#.......#.',
        '.#.......#.',
        '.#.....###.',
    ],
    首: [
        '...#....#..',
        '...#...#...',
        '###########',
        '....#......',
        '..#######..',
        '..#.....#..',
        '..#######..',
        '..#.....#..',
        '..#######..',
        '..#.....#..',
        '..#######..',
    ],
    頁: [
        '###########',
        '.....#.....',
        '..#######..',
        '..#.....#..',
        '..#######..',
        '..#.....#..',
        '..#######..',
        '..#.....#..',
        '..#######..',
        '..#.....#..',
        '##.......##',
    ],
    レ: [
        '#.......',
        '#.......',
        '#.......',
        '#.......',
        '#.......',
        '#......#',
        '#.....#.',
        '#....#..',
        '#..##...',
        '###.....',
    ],
    イ: [
        '........#',
        '.......#.',
        '......#..',
        '....##...',
        '..##.#...',
        '##...#...',
        '.....#...',
        '.....#...',
        '.....#...',
        '.....#...',
    ],
    ア: [
        '##########',
        '.........#',
        '........#.',
        '....#..#..',
        '....#.....',
        '....#.....',
        '....#.....',
        '....#.....',
        '...#......',
        '.##.......',
    ],
    ウ: [
        '....#....',
        '....#....',
        '#########',
        '#.......#',
        '#.......#',
        '#.......#',
        '.......#.',
        '.......#.',
        '......#..',
        '....##...',
        '..##.....',
    ],
    ト: [
        '#......',
        '#......',
        '#......',
        '#......',
        '###....',
        '#..##..',
        '#....##',
        '#......',
        '#......',
        '#......',
        '#......',
    ],
    終: [
        '..#...#....',
        '.#....####.',
        '#....#...#.',
        '###.#.#.#..',
        '..#....#...',
        '.#...##.#..',
        '####.....##',
        '..#...##...',
        '#.##....#..',
        '#.#..##....',
        '..#....###.',
    ],
    を: [
        '...#.....',
        '...#.....',
        '########.',
        '..#......',
        '..###....',
        '.#...#.##',
        '#...###..',
        '#..#.#...',
        '..#..#...',
        '..#......',
        '...#####.',
    ],
    削: [
        '..#.......#',
        '#.#..#.#..#',
        '#.#.#..#..#',
        '..#....#..#',
        '######.#..#',
        '#....#.#..#',
        '######.#..#',
        '#....#.#..#',
        '######....#',
        '#....#....#',
        '#...##...##',
    ],
    配: [
        '#####.#####',
        '.#.#......#',
        '.#.#......#',
        '#####.....#',
        '#.#.#.#####',
        '#.#.#.#....',
        '##.##.#....',
        '#...#.#....',
        '#####.#....',
        '#...#.#...#',
        '#####.#####',
    ],
    覧: [
        '#####.#....',
        '#.#...#####',
        '######.....',
        '#...#..####',
        '#######.#..',
        '#.#.....#..',
        '#########..',
        '..#.....#..',
        '..#######..',
        '...#..#...#',
        '###...#####',
    ],
    じ: [
        '.#....#.',
        '.#..#..#',
        '.#...#..',
        '#.......',
        '#.......',
        '#.......',
        '#.....#.',
        '#.....#.',
        '.#...#..',
        '..###...',
    ],
    る: [
        '.######.',
        '.....#..',
        '....#...',
        '...###..',
        '.##...#.',
        '#......#',
        '..##...#',
        '.#..#..#',
        '.#..#.#.',
        '..####..',
    ],
    く: [
        '....#.',
        '...#..',
        '..#...',
        '.#....',
        '#.....',
        '#.....',
        '.##...',
        '...#..',
        '....#.',
        '.....#',
    ],
    集: [
        '...#..#....',
        '..########.',
        '.##..#.....',
        '#.#######..',
        '..#..#.....',
        '..#######..',
        '.....#.....',
        '###########',
        '....##.#...',
        '..##.#..#..',
        '##...#...##',
    ],
    物: [
        '#.#.#......',
        '#.#.#######',
        '###.#.#.#.#',
        '#.##..#.#.#',
        '#.#..#..#.#',
        '..#..#.#..#',
        '..###..#..#',
        '###.#.#...#',
        '..#...#...#',
        '..#......#.',
        '..#....##..',
    ],
    駅: [
        '#####.#####',
        '#.#...#...#',
        '#####.#...#',
        '#.#...#...#',
        '#####.#####',
        '#.#...#.#..',
        '#####.#.#..',
        '....#.#..#.',
        '#.#.#.#..#.',
        '#...##....#',
        '..##.#....#',
    ],
    の: [
        '...#####..',
        '..#.#...#.',
        '.#..#....#',
        '#...#....#',
        '#..#.....#',
        '#..#.....#',
        '.##.....#.',
        '......##..',
    ],
    標: [
        '..#.#######',
        '..#...#.#..',
        '###########',
        '..#.#.#.#.#',
        '..#.#######',
        '.##........',
        '.##.#######',
        '#.#........',
        '#.#.#######',
        '..#..#.#.#.',
        '..#.#.##..#',
    ],
    グ: [
        '........#.',
        '...#..#..#',
        '...#...#..',
        '...#####..',
        '..#....#..',
        '.#.....#..',
        '#......#..',
        '......#...',
        '......#...',
        '.....#....',
        '...##.....',
        '###.......',
    ],
    ラ: [
        '.#######.',
        '.........',
        '.........',
        '#########',
        '........#',
        '........#',
        '.......#.',
        '......#..',
        '....##...',
        '..##.....',
    ],
    デ: [
        '.........#.',
        '.......#..#',
        '.######.#..',
        '...........',
        '...........',
        '##########.',
        '.....#.....',
        '.....#.....',
        '.....#.....',
        '.....#.....',
        '....#......',
        '..##.......',
    ],
    ー: ['#........', '.########'],
    シ: [
        '.##.......',
        '...##.....',
        '.........#',
        '##.......#',
        '..##....#.',
        '........#.',
        '.......#..',
        '......#...',
        '....##....',
        '.###......',
    ],
    ョ: ['######', '.....#', '.....#', '######', '.....#', '.....#', '######'],
    ン: [
        '##.......',
        '..##.....',
        '........#',
        '........#',
        '.......#.',
        '.......#.',
        '......#..',
        '.....#...',
        '...##....',
        '###......',
    ],
    非: [
        '....#..#...',
        '#####..####',
        '....#..#...',
        '....#..#...',
        '.####..####',
        '....#..#...',
        '....#..#...',
        '#####..#...',
        '....#..####',
        '...#...#...',
        '.##....#...',
    ],
    プ: [
        '........##.',
        '.......#..#',
        '########..#',
        '........##.',
        '........#..',
        '........#..',
        '........#..',
        '.......#...',
        '.......#...',
        '......#....',
        '....##.....',
        '..##.......',
    ],
    ビ: [
        '.......#.',
        '#....#..#',
        '#.....#..',
        '#........',
        '#....###.',
        '#####....',
        '#........',
        '#........',
        '#........',
        '#........',
        '.#######.',
    ],
    ュ: [
        '.#####..',
        '.....#..',
        '.....#..',
        '.....#..',
        '.....#..',
        '########',
    ],
    図: [
        '###########',
        '#...#.....#',
        '#....#..#.#',
        '#.#.....#.#',
        '#..#...#..#',
        '#....#.#..#',
        '#.....#...#',
        '#...##.#..#',
        '#.##....#.#',
        '#.........#',
        '###########',
    ],
    バ: [
        '........#.',
        '......#..#',
        '..#....#..',
        '..#.......',
        '..#.......',
        '..#....#..',
        '.#.....#..',
        '.#......#.',
        '.#......#.',
        '#........#',
        '#........#',
    ],
    ッ: [
        '#..#..#',
        '#..#..#',
        '#..#..#',
        '.....#.',
        '.....#.',
        '...##..',
        '.##....',
    ],
    太: [
        '.....#.....',
        '.....#.....',
        '###########',
        '.....#.....',
        '....#.#....',
        '....#.#....',
        '...#...#...',
        '...#...#...',
        '..#.....#..',
        '.#...#...#.',
        '#.....#...#',
    ],
    陽: [
        '###.######.',
        '#.#.#....#.',
        '#.#.######.',
        '##..#....#.',
        '#.#.#######',
        '#.#.#......',
        '#.#########',
        '#.#..#..#.#',
        '##..#..#..#',
        '#..#..#...#',
        '#....#..##.',
    ],
    オ: [
        '......#...',
        '......#...',
        '......#...',
        '##########',
        '......#...',
        '.....##...',
        '....#.#...',
        '..##..#...',
        '##....#...',
        '......#...',
        '....###...',
    ],
    ク: [
        '...#....',
        '...#....',
        '...#####',
        '..#....#',
        '.#.....#',
        '#......#',
        '......#.',
        '......#.',
        '.....#..',
        '...##...',
        '###.....',
    ],
    ル: [
        '.....#....',
        '..#..#....',
        '..#..#....',
        '..#..#....',
        '..#..#....',
        '..#..#...#',
        '..#..#...#',
        '.#...#..#.',
        '.#...#..#.',
        '#....#.#..',
        '#....##...',
    ],
    ジ: [
        '........#.',
        '......#..#',
        '.##....#..',
        '...##.....',
        '.........#',
        '##.......#',
        '..##....#.',
        '........#.',
        '.......#..',
        '......#...',
        '....##....',
        '.###......',
    ],
    エ: [
        '.#########.',
        '.....#.....',
        '.....#.....',
        '.....#.....',
        '.....#.....',
        '.....#.....',
        '.....#.....',
        '###########',
    ],
    ス: [
        '.#######..',
        '.......#..',
        '.......#..',
        '.......#..',
        '......#...',
        '......#...',
        '.....##...',
        '....#..#..',
        '..##....#.',
        '##.......#',
    ],
    ポ: [
        '.....#..##.',
        '.....#.#..#',
        '.....#.#..#',
        '##########.',
        '.....#.....',
        '.....#.....',
        '..#..#..#..',
        '.#...#...#.',
        '#....#....#',
        '.....#.....',
        '....##.....',
    ],
    両: [
        '###########',
        '.....#.....',
        '.....#.....',
        '###########',
        '#....#....#',
        '#.#..#..#.#',
        '#.#..#..#.#',
        '#.#..#..#.#',
        '#.#######.#',
        '#.........#',
        '#........##',
    ],
    '・': ['##', '##'],
    す: [
        '......#....',
        '......#....',
        '###########',
        '......#....',
        '....###....',
        '...#..#....',
        '...#..#....',
        '....###....',
        '......#....',
        '.....#.....',
        '...##......',
    ],
    べ: [
        '........#..',
        '......#..#.',
        '.......#...',
        '..###......',
        '.#...#.....',
        '#.....#....',
        '.......##..',
        '.........##',
    ],
    て: [
        '....######',
        '####..#...',
        '.....#....',
        '....#.....',
        '....#.....',
        '....#.....',
        '....#.....',
        '.....#....',
        '......###.',
    ],
    効: [
        '..#....#...',
        '######.#...',
        '......#####',
        '.#..#..#..#',
        '#....#.#..#',
        '.......#..#',
        '#...#..#..#',
        '.#.#..#...#',
        '..##..#...#',
        '.#..#....#.',
        '#....#.##..',
    ],
    な: [
        '....#......',
        '....#...##.',
        '#######...#',
        '...#.......',
        '...#....#..',
        '..#.....#..',
        '..#.....#..',
        '.#...####..',
        '.#..#...##.',
        '....#...#.#',
        '.....###...',
    ],
    タ: [
        '...#....',
        '...#....',
        '...#####',
        '..#....#',
        '.#.....#',
        '#..##..#',
        '.....##.',
        '......#.',
        '.....#..',
        '...##...',
        '###.....',
    ],
    ィ: ['.....#', '....#.', '..##..', '##.#..', '...#..', '...#..', '...#..'],
    か: [
        '..#.......',
        '..#....#..',
        '..#....#..',
        '#####...#.',
        '..#..#..#.',
        '..#..#...#',
        '.#...#...#',
        '.#...#....',
        '#....#....',
        '#....#....',
        '..###.....',
    ],
    ら: [
        '..##....',
        '....##..',
        '........',
        '#.......',
        '#.......',
        '#..###..',
        '###...#.',
        '.......#',
        '.......#',
        '.....##.',
        '..###...',
    ],
    済: [
        '......#....',
        '#..########',
        '.#..#....#.',
        '.....#..#..',
        '#....####..',
        '.#.##....##',
        '....######.',
        '.#..#....#.',
        '.#..######.',
        '#..#.....#.',
        '#..#.....#.',
    ],
    み: [
        '.#####.....',
        '.....#..#..',
        '.....#..#..',
        '.....#..#..',
        '..#######..',
        '.#..#...##.',
        '#...#...#.#',
        '#..#....#..',
        '.##....#...',
        '.....##....',
    ],
    操: [
        '.#...#####.',
        '.#...#...#.',
        '###.#######',
        '.#..#.#.#.#',
        '.#..#.#.#.#',
        '.#..###.###',
        '.##....#...',
        '##..#######',
        '.#....##...',
        '.#...#.#.#.',
        '##.##..#..#',
    ],
    ニ: [
        '.########.',
        '..........',
        '..........',
        '..........',
        '..........',
        '..........',
        '..........',
        '##########',
    ],
    替: [
        '..#.....#..',
        '#####.#####',
        '..#.....#..',
        '###########',
        '..#...#.#..',
        '.#...#...#.',
        '#.#######.#',
        '..#.....#..',
        '..#######..',
        '..#.....#..',
        '..#######..',
    ],
    択: [
        '.#...######',
        '.#...#....#',
        '####.#....#',
        '.#...#....#',
        '.#...######',
        '.#...#..#..',
        '.##..#..#..',
        '##...#...#.',
        '.#...#...#.',
        '.#..#.....#',
        '##..#.....#',
    ],
    し: [
        '.#.....',
        '.#.....',
        '.#.....',
        '#......',
        '#......',
        '#......',
        '#.....#',
        '#.....#',
        '.#...#.',
        '..###..',
    ],
    た: [
        '..#.......',
        '..#.......',
        '########..',
        '..#.......',
        '..#..####.',
        '..#.......',
        '.#...#....',
        '.#..#.....',
        '.#..#.....',
        '#....#####',
        '#.........',
    ],
    に: [
        '.#........',
        '.#...####.',
        '#.........',
        '#.........',
        '#.........',
        '#....#....',
        '#...#.....',
        '#...#.....',
        '.#...#####',
        '.#........',
    ],
    フ: [
        '#########',
        '........#',
        '........#',
        '........#',
        '........#',
        '.......#.',
        '.......#.',
        '......#..',
        '....##...',
        '.###.....',
    ],
    ォ: [
        '....#..',
        '....#..',
        '#######',
        '....#..',
        '...##..',
        '..#.#..',
        '##..#..',
        '...##..',
    ],
    カ: [
        '....#.....',
        '....#.....',
        '....#.....',
        '##########',
        '....#....#',
        '....#....#',
        '....#....#',
        '...#.....#',
        '...#.....#',
        '..#......#',
        '##....###.',
    ],
    追: [
        '.#....#....',
        '..#..#####.',
        '.....#...#.',
        '#....#####.',
        '.#...#.....',
        '.....#####.',
        '###..#...#.',
        '..#..#...#.',
        '..#..#####.',
        '.#.#.......',
        '#...#######',
    ],
    跡: [
        '####...#...',
        '#..#...#...',
        '#..########',
        '####..#.#..',
        '..#...#.#..',
        '..#.#.#.#.#',
        '#.#.#.#.#.#',
        '#.##..#.#.#',
        '#.#...#.#..',
        '#.#..#..#..',
        '#####..##..',
    ],
    が: [
        '..#.....#.',
        '..#...#..#',
        '..#....#..',
        '#####.....',
        '..#..#..#.',
        '..#..#..#.',
        '.#...#...#',
        '.#...#...#',
        '#....#....',
        '#....#....',
        '..###.....',
    ],
    あ: [
        '....#.....',
        '....#..##.',
        '#######...',
        '...#......',
        '...#####..',
        '..##..#.#.',
        '.#.#..#..#',
        '#..#.#...#',
        '#..##....#',
        '.##.#...#.',
        '......##..',
    ],
    り: [
        '#....#',
        '#....#',
        '#....#',
        '#....#',
        '#....#',
        '#.#..#',
        '.#...#',
        '.....#',
        '....#.',
        '..##..',
    ],
    ま: [
        '.....#...',
        '.....#...',
        '#########',
        '.....#...',
        '.########',
        '.....#...',
        '.....#...',
        '..####...',
        '.#...###.',
        '.#...#..#',
        '..###....',
    ],
    せ: [
        '.......#..',
        '..#....#..',
        '..#....#..',
        '..#..#####',
        '#####..#..',
        '..#....#..',
        '..#....#..',
        '..#..###..',
        '..#.......',
        '..#.......',
        '...######.',
    ],
    ん: [
        '....#.....',
        '....#.....',
        '...#......',
        '...#......',
        '..#.##....',
        '..##..#...',
        '.#....#...',
        '.#....#..#',
        '#.....#..#',
        '#......##.',
    ],
    テ: [
        '.########.',
        '..........',
        '..........',
        '##########',
        '.....#....',
        '.....#....',
        '.....#....',
        '.....#....',
        '....#.....',
        '..##......',
    ],
    ホ: [
        '.....#.....',
        '.....#.....',
        '.....#.....',
        '###########',
        '.....#.....',
        '.....#.....',
        '..#..#..#..',
        '.#...#...#.',
        '#....#....#',
        '.....#.....',
        '....##.....',
    ],
    ム: [
        '....#.....',
        '....#.....',
        '....#.....',
        '....#.....',
        '...#......',
        '...#....#.',
        '...#....#.',
        '..#.....#.',
        '..#..###.#',
        '#####....#',
        '.........#',
    ],
    キ: [
        '....#.....',
        '....#.....',
        '....#.....',
        '#########.',
        '....#.....',
        '....#.....',
        '....#.....',
        '##########',
        '.....#....',
        '.....#....',
        '.....#....',
    ],
    ャ: [
        '..#....',
        '..#....',
        '..#.###',
        '####..#',
        '..#..#.',
        '...#.#.',
        '...#...',
        '...#...',
    ],
    セ: [
        '....#......',
        '....#......',
        '....#...###',
        '....#.##..#',
        '...###...#.',
        '###.#....#.',
        '....#...#..',
        '....#......',
        '....#......',
        '....#......',
        '.....######',
    ],
    ブ: [
        '.........#.',
        '......#...#',
        '.......#...',
        '#########..',
        '........#..',
        '........#..',
        '........#..',
        '.......#...',
        '.......#...',
        '......#....',
        '....##.....',
        '..##.......',
    ],
    盤: [
        '..#...####.',
        '.####.#..#.',
        '.#..##...##',
        '.##.#.####.',
        '.#..#.#..#.',
        '#####..##..',
        '.#..#.#..##',
        '.#########.',
        '.#..#.#..#.',
        '.#..#.#..#.',
        '###########',
    ],
    幅: [
        '..#.#######',
        '..#........',
        '..#..#####.',
        '####.#...#.',
        '#.#..#####.',
        '#.#........',
        '#.#.#######',
        '#.#.#..#..#',
        '#.#.#######',
        '..#.#..#..#',
        '..#.#######',
    ],
    ナ: [
        '.....#....',
        '.....#....',
        '.....#....',
        '##########',
        '.....#....',
        '.....#....',
        '.....#....',
        '....#.....',
        '....#.....',
        '...#......',
        '.##.......',
    ],
    さ: [
        '.....#...',
        '.....#...',
        '.....#.##',
        '#######..',
        '......#..',
        '......#..',
        '..####.#.',
        '.#....##.',
        '.#.......',
        '..#......',
        '...####..',
    ],
    階: [
        '###.#...#..',
        '#.#.###.###',
        '#.#.#...#..',
        '##..#...#..',
        '#.#.###.###',
        '#.#....#...',
        '#.#.#######',
        '#.#.#.....#',
        '##..#######',
        '#...#.....#',
        '#...#######',
    ],
    続: [
        '..#....#...',
        '.#..#######',
        '#......#...',
        '###..######',
        '..#........',
        '.#..#######',
        '#####.....#',
        '..#...#.#..',
        '#.#...#.#..',
        '#.#..#..#.#',
        '..###...###',
    ],
    番: [
        '.#########.',
        '..#..#..#..',
        '...#.#.#...',
        '###########',
        '...#.#..#..',
        '..#..#...#.',
        '#########.#',
        '..#..#..#..',
        '..#######..',
        '..#..#..#..',
        '..#######..',
    ],
    号: [
        '..#######..',
        '..#.....#..',
        '..#.....#..',
        '..#######..',
        '...........',
        '###########',
        '...#.......',
        '..########.',
        '..#......#.',
        '........#..',
        '.....###...',
    ],
    メ: [
        '......#...',
        '......#...',
        '......#...',
        '......#...',
        '.##...#...',
        '...###....',
        '.....###..',
        '.....#..##',
        '....#.....',
        '..##......',
        '##........',
    ],
    画: [
        '###########',
        '.....#.....',
        '..#######..',
        '..#..#..#..',
        '#.#..#..#.#',
        '#.#######.#',
        '#.#..#..#.#',
        '#.#..#..#.#',
        '#.#######.#',
        '#.........#',
        '###########',
    ],
    像: [
        '..#..#####.',
        '..#.#...#..',
        '.#.########',
        '.#..#..#..#',
        '##..#..#..#',
        '.#..#######',
        '.#...#..#..',
        '.#.##..##.#',
        '.#...##.##.',
        '.#.##...#.#',
        '.#....##...',
    ],
    は: [
        '.......#..',
        '.#.....#..',
        '.#.....#..',
        '#..#######',
        '#......#..',
        '#......#..',
        '#......#..',
        '#...####..',
        '#..#...##.',
        '.#.#...#.#',
        '.#..###...',
    ],
    つ: [
        '...####..',
        '###....#.',
        '........#',
        '........#',
        '........#',
        '.......#.',
        '.....##..',
        '..###....',
    ],
    必: [
        '...##......',
        '.....#..#..',
        '........#..',
        '...#...#...',
        '.#.#...#.#.',
        '.#.#..#..#.',
        '#..#.#....#',
        '#..##.....#',
        '...#....#..',
        '..##....#..',
        '##..####...',
    ],
    で: [
        '....######.',
        '####..#....',
        '.....#...#.',
        '....#..#..#',
        '....#...#..',
        '....#......',
        '....#......',
        '.....#.....',
        '......###..',
    ],
    ァ: [
        '#######',
        '......#',
        '...#..#',
        '...#.#.',
        '...#...',
        '..#....',
        '.#.....',
    ],
    内: [
        '.....#.....',
        '.....#.....',
        '###########',
        '#....#....#',
        '#....#....#',
        '#...#.#...#',
        '#..#...#..#',
        '#.#.....#.#',
        '#.........#',
        '#.........#',
        '#.......###',
    ],
    押: [
        '.#..#######',
        '.#..#..#..#',
        '###.#..#..#',
        '.#..#######',
        '.#..#..#..#',
        '.#..#..#..#',
        '.##.#######',
        '##.....#...',
        '.#.....#...',
        '.#.....#...',
        '##.....#...',
    ],
    だ: [
        '........#.',
        '..#...#..#',
        '..#....#..',
        '#######...',
        '..#.......',
        '..#..####.',
        '..#.......',
        '.#...#....',
        '.#..#.....',
        '.#..#.....',
        '#....#####',
        '#.........',
    ],
    い: [
        '.#........',
        '.#.....#..',
        '#.......#.',
        '#.......#.',
        '#........#',
        '#....#...#',
        '.#..#.....',
        '..##......',
    ],
    ネ: [
        '.....#.....',
        '.....#.....',
        '.########..',
        '........#..',
        '.......#...',
        '......#....',
        '.....##....',
        '...###.##..',
        '###..#...##',
        '.....#.....',
        '.....#.....',
    ],
    れ: [
        '..#.......',
        '..#.......',
        '..#.......',
        '###..###..',
        '..#.#...#.',
        '..##....#.',
        '..#.....#.',
        '.##....#..',
        '#.#....#..',
        '..#....#..',
        '..#.....##',
    ],
    む: [
        '...#......',
        '...#......',
        '######.##.',
        '...#.....#',
        '...#......',
        '.###......',
        '#..#......',
        '#..#....#.',
        '.###....#.',
        '...#....#.',
        '....####..',
    ],
    構: [
        '..#..#..#..',
        '..#.#######',
        '####.#..#..',
        '..#.#######',
        '..#..#..#..',
        '.##.#######',
        '.##.#..#..#',
        '#.#.#######',
        '#.#.#..#..#',
        '..#########',
        '..#.#.....#',
    ],
    次: [
        '.....#.....',
        '.....######',
        '###..#.#..#',
        '....#..#..#',
        '....#..#.#.',
        '.......#...',
        '..#....#...',
        '.#....#.#..',
        '#.....#.#..',
        '.....#...#.',
        '...##.....#',
    ],
    ザ: [
        '..#....#.#.',
        '..#....#..#',
        '..#....##..',
        '########.#.',
        '..#....#...',
        '..#....#...',
        '..#....#...',
        '......#....',
        '......#....',
        '....##.....',
        '..##.......',
    ],
    瞰: [
        '...######..',
        '###..#..###',
        '#.#######.#',
        '###.#.#.#.#',
        '#.#.###...#',
        '#.#.#.#.#.#',
        '###.###.#.#',
        '#.#.#.#..#.',
        '#.#.#.#..#.',
        '#######.#.#',
        '......##..#',
    ],
    鉄: [
        '..##..#.#..',
        '.#..#.#.#..',
        '#.....#####',
        '####.#..#..',
        '..#..#..#..',
        '#####.#####',
        '..#.....#..',
        '#.#.#...#..',
        '#.#.#..#.#.',
        '..#...#...#',
        '######....#',
    ],
    ミ: [
        '.###...',
        '....###',
        '.......',
        '.......',
        '.###...',
        '....##.',
        '.......',
        '.......',
        '####...',
        '....###',
    ],
    そ: [
        '..######..',
        '......#...',
        '.....#....',
        '....#.....',
        '##########',
        '....#.....',
        '...#......',
        '...#......',
        '...#......',
        '....####..',
    ],
    も: [
        '...#.....',
        '...#.....',
        '########.',
        '...#.....',
        '...#.....',
        '########.',
        '..#......',
        '..#.....#',
        '..#.....#',
        '...#...#.',
        '....###..',
    ],
    っ: ['..###..', '##...#.', '......#', '......#', '.....#.', '..###..'],
    と: [
        '..#....',
        '..#....',
        '..#....',
        '...#...',
        '...####',
        '..##...',
        '.#.....',
        '#......',
        '#......',
        '.#.....',
        '..#####',
    ],
    ベ: [
        '.........#.',
        '.......#..#',
        '........#..',
        '...........',
        '...###.....',
        '..#...#....',
        '.#.....#...',
        '#.......#..',
        '.........#.',
        '..........#',
    ],
    よ: [
        '....#...',
        '....#...',
        '....#...',
        '....####',
        '....#...',
        '....#...',
        '....#...',
        '.####...',
        '#...###.',
        '#...#..#',
        '.###....',
    ],
    敷: [
        '..#..#.#...',
        '######.####',
        '..#....#.#.',
        '#######..#.',
        '#.#..#...#.',
        '######.#.#.',
        '#.#..#.#.#.',
        '#######.#..',
        '..#..#..#..',
        '.#...#.#.#.',
        '#..##.#...#',
    ],
    ハ: [
        '..#.......',
        '..#....#..',
        '..#....#..',
        '..#.....#.',
        '.#......#.',
        '.#......#.',
        '.#.......#',
        '#........#',
        '#........#',
        '#........#',
    ],
    マ: [
        '##########',
        '.........#',
        '........#.',
        '.......#..',
        '..#...#...',
        '...#.#....',
        '....#.....',
        '.....#....',
        '......#...',
    ],
    柔: [
        '..#######..',
        '.......#...',
        '....#.#....',
        '.#########.',
        '....##...#.',
        '..##.#..#..',
        '.....#.....',
        '###########',
        '....##.#...',
        '..##.#..#..',
        '##...#...##',
    ],
    軟: [
        '..#...#....',
        '#####.#####',
        '..#...#.#.#',
        '#####.#.#.#',
        '#.#.#.#.#.#',
        '#####...#..',
        '#.#.#...#..',
        '#####..#.#.',
        '..#....#.#.',
        '#####.#...#',
        '..#..#....#',
    ],
    ズ: [
        '......#..#.',
        '.......#..#',
        '.#######...',
        '.......#...',
        '.......#...',
        '.......#...',
        '......#....',
        '......#....',
        '.....##....',
        '....#..#...',
        '..##....#..',
        '##.......#.',
    ],
    ゲ: [
        '.........#.',
        '..#....#..#',
        '..#.....#..',
        '..#........',
        '..########.',
        '.#....#....',
        '#.....#....',
        '......#....',
        '.....#.....',
        '.....#.....',
        '...##......',
        '.##........',
    ],
    ド: [
        '#.....#.',
        '#...#..#',
        '#....#..',
        '#.......',
        '###.....',
        '#..##...',
        '#....##.',
        '#.......',
        '#.......',
        '#.......',
        '#.......',
    ],
    モ: [
        '.########..',
        '....#......',
        '....#......',
        '....#......',
        '###########',
        '....#......',
        '....#......',
        '....#......',
        '....#......',
        '.....####..',
    ],
    こ: [
        '.######.',
        '........',
        '........',
        '........',
        '........',
        '.#......',
        '#.......',
        '#......#',
        '.######.',
    ],
    ど: [
        '.......#.',
        '..#..#..#',
        '..#...#..',
        '..#......',
        '...#.....',
        '...####..',
        '..##.....',
        '.#.......',
        '#........',
        '#........',
        '.#.......',
        '..#####..',
    ],
    繋: [
        '...#..####.',
        '#######..#.',
        '.#.#.#...##',
        '.#########.',
        '.#.#.#...#.',
        '######.##..',
        '...#..#..##',
        '..#..#..#..',
        '###########',
        '..#..#..#..',
        '##...#...##',
    ],
};
